import { Box, Button, Container, makeStyles, Typography } from '@material-ui/core';
import React from 'react'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { startAlerta } from '../../../actions/ui/alertas';
import { finishSpinner, startSpinner } from '../../../actions/ui/spinner';
import { useForm } from '../../../hooks/useForm';
import AfiliadoService from '../../../services/AfiliadoService'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  submit: {
    marginTop: "1rem",
    textTransform: "none"
  },
  title: {
    fontWeight: "bold"
  }
}));

const RegisterScreen = (props) => {
  const { history } = props
  const classes = useStyles()
  const dispatch = useDispatch()

  const initialState = {
    dni: "",
  };

  const [formValues, handleInputChange] = useForm(initialState);
  const { dni} = formValues;

  const handleRegister = async (e) => {
    e.preventDefault();
        try {
            dispatch(startSpinner())
            const result=await AfiliadoService.registro(dni)
            const body=await result.json()
            if(result.ok){
                // if(moment(body.fechaAlta).isBefore('2021-08-02') || body.email===null){
                  history.push(`/afiliado/registro-sin-email/${dni}`)
                // }else{
                //   dispatch(startAlerta("¡Tu registro fue exitoso! Te enviaremos un correo electrónico con los datos de acceso.", "success"))
                //   history.push("/afiliado/login")
                // }
                dispatch(finishSpinner())
            }else{
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if(error.mensaje){
                dispatch(startAlerta(error.mensaje, "error"))
            }else{
                dispatch(startAlerta("Ha ocurrido un error en el registro. Intente nuevamente.", "error"))
            }
            console.log("Error en el registro del usuario", error)
        }
};

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <ValidatorForm onSubmit={handleRegister}>
            <Box p="1rem">
              <Typography align="center" variant="h4" className={classes.title} color="secondary">Registro</Typography>
              <Typography variant="body2" align="justify" style={{marginTop:"1rem"}}>Por favor, ingresá tu número de documento para identificarte dentro del sistema.</Typography>

              <TextValidator
                variant="outlined"
                margin="normal"
                fullWidth
                label="DNI"
                onChange={handleInputChange}
                name="dni"
                validators={['required']}
                errorMessages={['El DNI es requerido']}
                value={dni}
                />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Siguiente
              </Button>
              <Button
                component={Link}
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                className={classes.submit}
                to="/afiliado/ingreso"
              >
                Anterior
              </Button>
              <Typography variant="body2" align="justify" style={{marginTop:"1rem"}}>Una vez que te identifiques, recibirás un correo electrónico con la información de acceso a tu cuenta.</Typography>

            </Box>
          </ValidatorForm>
        </Container>
      </Box>
    </div>
  )
}

export default RegisterScreen
